import { Link } from 'react-router-dom'
import { Alert, ComingSoonBanner } from '../components/Alert'
import { EmptyState } from '../components/States'

const ENTITIES = [
  'Customer', 'Vendor', 'Product / Service', 'Chart of Accounts', 'Class',
  'Invoice', 'Expense', 'Journal Entry',
]

export function QuickCreatePage() {
  return (
    <div className="wrap" style={{ maxWidth: 1000 }}>
      <div className="phead">
        <div>
          <div className="crumb">
            <Link to="/app">Home</Link> / Quick create
          </div>
          <h2>Quick create</h2>
          <p className="fs13 muted" style={{ margin: '6px 0 0' }}>
            Type a handful of records straight into a grid without preparing a file. Good for the ten
            customers you are missing.
          </p>
        </div>
        <span className="spacer" />
        <span className="tagp t-p1">P1</span>
        <span className="pill">1 credit per line</span>
      </div>

      <ComingSoonBanner feature="Quick create" />

      <div className="card">
        <div className="card-h">
          <select className="inp" style={{ width: 200, height: 32 }} defaultValue={ENTITIES[0]}>
            {ENTITIES.map((name) => (
              <option key={name}>{name}</option>
            ))}
          </select>
          <span className="spacer" />
          <button className="btn btn-g btn-sm" type="button" disabled>
            Paste from clipboard
          </button>
          <button className="btn btn-g btn-sm" type="button" disabled>
            + Add 5 rows
          </button>
        </div>
        <EmptyState
          icon="✎"
          title="The grid is not wired up yet"
          body="Quick create writes records one at a time through an endpoint that is not in the current API. The entity picker above is the shipped design."
        />
        <div className="card-f">
          <span className="fs13 muted">
            <b>0</b> ready · <b>0</b> with problems · <b className="mono">0 credits</b>
          </span>
          <span className="spacer" />
          <button className="btn btn-g btn-sm" type="button" disabled>
            Clear grid
          </button>
          <button className="btn btn-p" type="button" disabled>
            Create records
          </button>
        </div>
      </div>

      <Alert
        tone="info"
        title="Duplicate names are checked against QuickBooks as you type"
        style={{ marginTop: 16 }}
      >
        QuickBooks requires display names to be unique across customers, vendors and employees, so a
        clashing row is flagged before you spend a credit on it.
      </Alert>
    </div>
  )
}
